import styled from 'styled-components';
import { Button } from 'antd';

export const StyledTabContainer = styled.div`
  /* Style antd's built-in tab content holder */
  .ant-tabs-content-holder {
    padding: 16px 0;
  }
`;

export const StyledDeleteButton = styled(Button)`
  margin-top: 16px;
`;
